export enum AuthRouteEnum {
  Auth = '/auth',
  Login = '/auth/login',
  ForgotPassword = '/auth/password/forgot',
  ChangePassword = '/auth/password/change',
}
